import PropTypes from "prop-types";
// material
import { Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

ProductVarietyBadge.propTypes = {
  specification: PropTypes.string,
  selectedVarieties: PropTypes.object,
  sx: PropTypes.object,
};

export default function ProductVarietyBadge({
  specification = "",
  selectedVarieties = null,
  sx = {},
}) {
  const theme = useTheme();

  let formattedText = specification;
  if (!formattedText && selectedVarieties && typeof selectedVarieties === "object") {
    const entries = Object.entries(selectedVarieties);
    if (entries.length > 0) {
      formattedText = entries
        .map(([key, val]) => `${key}: ${val}`)
        .join(" | ");
    }
  }

  if (!formattedText) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 0.5,
        display: "inline-flex",
        alignItems: "center",
        px: 0.8,
        py: 0.25,
        borderRadius: "4px",
        backgroundColor:
          theme.palette.mode === "light"
            ? alpha(theme.palette.info.main, 0.08)
            : alpha(theme.palette.info.main, 0.16),
        border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
        maxWidth: "100%",
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color:
            theme.palette.mode === "light"
              ? theme.palette.info.dark
              : theme.palette.info.light,
          fontWeight: 600,
          fontSize: "0.75rem",
          lineHeight: 1.3,
          wordBreak: "break-word",
        }}
      >
        <Box component="span" sx={{ fontWeight: 700, mr: 0.5, opacity: 0.8 }}>
          Spec:
        </Box>
        {formattedText}
      </Typography>
    </Box>
  );
}
